import { Injectable } from '@angular/core';
import { OrganizationService } from '@nimmsta/ng-commons-lib';

@Injectable({ providedIn: 'root' })
export class OrganizationNameService extends OrganizationService {}
